var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('FilterToolbar',{attrs:{"allowFilters":false,"hasChanges":_vm.hasChanges,"appliedFilters":_vm.appliedFilters},on:{"search":_vm.search,"update":_vm.update,"clear":_vm.clear}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }